import { render, staticRenderFns } from "./FileResourceTypeModal.vue?vue&type=template&id=52d25cb4&"
import script from "./FileResourceTypeModal.vue?vue&type=script&lang=js&"
export * from "./FileResourceTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports